import { ObjectOps } from '../lift';
/**
 * Filter keys/values of a "Map" object
 */
export function filter(predicate) {
    var obj = this.value(), result = {};
    Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        if (predicate(key, value))
            result[key] = value;
    });
    return new ObjectOps(result);
}
ObjectOps.prototype.filter = filter;
